import clsx from 'clsx';
import { KEYBOARD_EVENTS } from '../../../../utils/constants/commonConstants';
import { ALL_KNOWN_DETAILS_TESTIDS } from '../../constants';
import styles from './MoreValuesTrigger.module.scss';

interface MoreValuesTriggerProps {
    count: number;
    noun?: string;
    onActivate?: () => void;
    describedBy?: string;
    inline?: boolean;
    className?: string;
}

const MoreValuesTrigger = ({ count, noun, onActivate, describedBy, inline, className }: MoreValuesTriggerProps) => {
    if (count < 1) return null;

    const buttonProps = onActivate && {
        role: 'button',
        tabIndex: 0,
        onClick: onActivate,
        onKeyDown: (e: React.KeyboardEvent) => {
            if (e.key === KEYBOARD_EVENTS.ENTER || e.key === KEYBOARD_EVENTS.SPACE) onActivate();
        },
    };

    return (
        <span
            className={clsx(styles.MoreTrigger, inline && styles.MoreTriggerInline, className)}
            data-testid={ALL_KNOWN_DETAILS_TESTIDS.MORE_TRIGGER}
            aria-describedby={describedBy}
            {...buttonProps}
        >
            {`+${count} more${noun ? ` ${noun}` : ''}`}
        </span>
    );
};

export default MoreValuesTrigger;
